import type { ActiveContext } from '@/types/active-context'
import { HOME_BY_ROLE } from './route-registry'

/** Home route after switching active context (personal vs organization). */
export function getHomeRouteForContext(context: ActiveContext): string {
  if (context.scope === 'organization') {
    // Owners/admins land on org dashboard; members land on analyzer
    return context.isOwner || context.isAdmin
      ? HOME_BY_ROLE.organization_owner
      : HOME_BY_ROLE.organization_member
  }
  return HOME_BY_ROLE.individual
}
